import Vue from 'vue'
import Vuex from 'vuex'

import autologin from 'store/modules/autologin'
import login from 'store/modules/login'
import dash from 'store/modules/dash'
import hrms76x from 'store/modules/hrms76x'
import hrms74e from 'store/modules/hrms74e'
import hrms62e from 'store/modules/hrms62e'
import hrms6ke from 'store/modules/hrms6ke'
import hrms6ae from 'store/modules/hrms6ae'
import hrms32e from 'store/modules/hrms32e'
import hrms31e from 'store/modules/hrms31e'
import hrms27u from 'store/modules/hrms27u'
import hrms19x from 'store/modules/hrms19x'
import hrms18e from 'store/modules/hrms18e'
import hrms17e from 'store/modules/hrms17e'
import hrms16x from 'store/modules/hrms16x'
import hrms15e from 'store/modules/hrms15e'
import hrms14x from 'store/modules/hrms14x'
import hrms13x from 'store/modules/hrms13x'
import hrms12x from 'store/modules/hrms12x'
import hrms1ax from 'store/modules/hrms1ax'
import hrms55x from 'store/modules/hrms55x'
import hress5u from 'store/modules/hress5u'
import hress3u from 'store/modules/hress3u'
import hres96u from 'store/modules/hres96u'
import hres94u from 'store/modules/hres94u'
import hres92u from 'store/modules/hres92u'
import hres89u from 'store/modules/hres89u'
import hres87u from 'store/modules/hres87u'
import hres85u from 'store/modules/hres85u'
import hres82e from 'store/modules/hres82e'
import hres83e from 'store/modules/hres83e'
import hres81x from 'store/modules/hres81x'
import hresh1x from 'store/modules/hresh1x'
import hres78u from 'store/modules/hres78u'
import hres75u from 'store/modules/hres75u'
import hres72u from 'store/modules/hres72u'
import hres62e from 'store/modules/hres62e'
import hres6eu from 'store/modules/hres6eu'
import hres6ju from 'store/modules/hres6ju'
import hres6ke from 'store/modules/hres6ke'
import hres6lu from 'store/modules/hres6lu'
import hres6me from 'store/modules/hres6me'
import hres6nu from 'store/modules/hres6nu'
import hres63u from 'store/modules/hres63u'
import hres6ae from 'store/modules/hres6ae'
import hres6bu from 'store/modules/hres6bu'
import hres6de from 'store/modules/hres6de'
import hres3cu from 'store/modules/hres3cu'
import hres37u from 'store/modules/hres37u'
import hres35u from 'store/modules/hres35u'
import hres33u from 'store/modules/hres33u'
import hres32e from 'store/modules/hres32e'
import hres31x from 'store/modules/hres31x'
import hrms73e from 'store/modules/hrms73e'
import hrms75e from 'store/modules/hrms75e'
import hres7de from 'store/modules/hres7de'
import hress1e from 'store/modules/hress1e'
import hres4ax from 'store/modules/hres4ax'
import hres7fe from 'store/modules/hres7fe'
import hrms41e from 'store/modules/hrms41e'
import hres8ax from 'store/modules/hres8ax'
import requestall from 'store/modules/requestall'
import contact from 'store/modules/contact'
import knowledge from 'store/modules/knowledge'
import calendar from 'store/modules/calendar'
import poll from 'store/modules/poll'
import warningmsg from 'store/modules/warningmsg'
import hrmsCalendarWorkTime from 'store/modules/hrmsCalendarWorkTime'
import hrmsLovCodcomp from 'store/modules/hrmsLovCodcomp'
import hrmsLovCodcomp2 from 'store/modules/hrmsLovCodcomp2'
import hrmsLov from 'store/modules/hrmsLov'
import hrmsDropzone from 'store/modules/hrmsDropzone'
import votefriend from 'store/modules/votefriend'
import hres6oe from 'store/modules/hres6oe'
import hres80x from 'store/modules/hres80x'
import profileimg from 'store/modules/profileimg'
import hres88e from 'store/modules/hres88e'
import stdapplinf from 'store/modules/stdapplinf'
import stdreq from 'store/modules/stdreq'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    autologin,
    login,
    dash,
    hrms76x,
    hrms74e,
    hrms62e,
    hrms6ke,
    hrms6ae,
    hrms32e,
    hrms31e,
    hrms27u,
    hrms19x,
    hrms18e,
    hrms17e,
    hrms16x,
    hrms15e,
    hrms14x,
    hrms13x,
    hrms12x,
    hrms1ax,
    hrms55x,
    hress5u,
    hress3u,
    hres96u,
    hres94u,
    hres92u,
    hres89u,
    hres87u,
    hres85u,
    hres82e,
    hres83e,
    hres81x,
    hresh1x,
    hres78u,
    hres75u,
    hres72u,
    hres62e,
    hres6eu,
    hres6ju,
    hres6ke,
    hres6lu,
    hres6me,
    hres6nu,
    hres63u,
    hres6ae,
    hres6bu,
    hres6de,
    hres3cu,
    hres37u,
    hres35u,
    hres33u,
    hres32e,
    hres31x,
    hrms73e,
    hrms75e,
    hres7de,
    hress1e,
    hres4ax,
    hres7fe,
    hrms41e,
    hres8ax,
    requestall,
    contact,
    knowledge,
    calendar,
    poll,
    warningmsg,
    hrmsCalendarWorkTime,
    hrmsLovCodcomp,
    hrmsLovCodcomp2,
    hrmsLov,
    hrmsDropzone,
    votefriend,
    hres6oe,
    hres80x,
    profileimg,
    hres88e,
    stdapplinf,
    stdreq
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js